import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../types'

const moderationListedItems = (state: RootState) => state.moderationListedItems
export const selectLoading = createSelector(
  moderationListedItems,
  (state) => state.loading
)
export const selectItemsList = createSelector(
  moderationListedItems,
  (state) => state.itemsList
)
export const selectItemState = createSelector(
  moderationListedItems,
  (state) => state.itemsState
)
export const selectQueryParams = createSelector(
  moderationListedItems,
  (state) => state.query
)
export const selectTotalPages = createSelector(
  moderationListedItems,
  (state) => state.totalPages
)
export const selectNeedApply = createSelector(
  moderationListedItems,
  (state) => state.needApply
)
export const selectFirstRender = createSelector(
  moderationListedItems,
  (state) => state.firstRender
)
export const selectCategories = createSelector(
  moderationListedItems,
  (state) => state.categories
)
export const selectNonprofits = createSelector(
  moderationListedItems,
  (state) => state.nonprofits
)
export const selectIsFilterCollapsed = createSelector(
  moderationListedItems,
  (state) => state.isFilterCollapsed
)
export const selectError = createSelector(
  moderationListedItems,
  (state) => state.error
)
export const selectIsModerator = createSelector(
  moderationListedItems,
  (state) => state.isModerator
)
export const selectModerationState = createSelector(
  moderationListedItems,
  (state) => state.moderationState
)

